import './LoginPage.css';
import React from 'react';
import { Link } from 'react-router-dom';

const LoginPage = () => {
  return (
    <div className="login-page">
      <div className="login-container">
        <h2>Login</h2>
        <p>Authentication is coming soon.</p>
        <div className="login-links">
          <p>Don't have an account? <Link to="/signup">Sign up here</Link></p>
          <p>Forgot password? <Link to="/forgot-password">Reset password</Link></p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
